import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const organizationUnit = createCrudVuexModule({
  namespaced: true,
  path: "/unit",
  state: {
    graph: undefined,
    processGraph: undefined,
  },

  getters: {
    graph: (state) => state.graph,
    processGraph: (state) => state.processGraph,
  },

  mutations: {
    graph: (state, value) => (state.graph = value),
    processGraph: (state, value) => (state.processGraph = value),
  },

  actions: {
    async paginateForSelect({}, pagination) {
      return rest.post("/unit/paginate", { pagination });
    },

    async clearSelectedEntity({ commit }) {
      commit("selectedEntity", undefined);
    },

    async addFromLibrary({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post("/unit/add-from-library", payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async graph({ commit }, { department, unit }) {
      commit("isLoading", true);
      try {
        commit("graph", undefined);

        let url = "/unit/graph";
        if (department) {
          url += `?department=${department._id}`;
        }
        if (unit) {
          if (department) {
            url += `&unit=${unit._id}`;
          } else {
            url += `?unit=${unit._id}`;
          }
        }

        const response = await rest.get(url);
        commit("graph", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },
    async processGraph({ commit }, id) {
      commit("isLoading", true);
      try {
        commit("processGraph", undefined);
        const response = await rest.get(`/unit/${id}/process/graph`);
        commit("processGraph", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },
  },
});
